import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { DeclineProposedTimeContainer } = await import('./index');
    return {
        Component: DeclineProposedTimeContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
